var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComputer({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 25,
    viewBox: "0 0 30 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.47221 0C1.55456 0 0 1.55456 0 3.47221V17.361C0 19.2787 1.55456 20.8332 3.47221 20.8332H12.0708L10.6819 23.611H7.63886C7.25533 23.611 6.94442 23.922 6.94442 24.3055C6.94442 24.6889 7.25533 24.9999 7.63886 24.9999H11.096C11.1057 25 11.1154 25 11.125 24.9999H18.0416C18.0512 25 18.0608 25 18.0705 24.9999H21.5277C21.9112 24.9999 22.2221 24.6889 22.2221 24.3055C22.2221 23.922 21.9112 23.611 21.5277 23.611H18.4846L17.0958 20.8332H25.6943C27.612 20.8332 29.1665 19.2787 29.1665 17.361V3.47221C29.1665 1.55456 27.612 0 25.6943 0H3.47221ZM16.9319 23.611L15.543 20.8332H13.6236L12.2347 23.611H16.9319ZM15.957 19.4444C15.9667 19.4442 15.9765 19.4442 15.9862 19.4444H25.6943C26.8449 19.4444 27.7777 18.5116 27.7777 17.361V3.47221C27.7777 2.32162 26.8449 1.38888 25.6943 1.38888H3.47221C2.32162 1.38888 1.38888 2.32162 1.38888 3.47221V17.361C1.38888 18.5116 2.32162 19.4444 3.47221 19.4444H13.1804C13.1901 19.4442 13.1998 19.4442 13.2094 19.4444H15.957Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputer);
export default __webpack_public_path__ + "static/media/computer.104a9ec082a6df83f688483664814d1f.svg";
export { ForwardRef as ReactComponent };